import { i18n } from 'core/localization';
import { BindableVariableValue } from '../types';

export function formatVariableValue(value: BindableVariableValue | undefined) {
	if (value === undefined) {
		return i18n('Loading...');
	}

	if (value === null) {
		return '—';
	}

	if (typeof value == 'boolean') {
		return value ? i18n('True') : i18n('False');
	}

	return Array.isArray(value) ? value.join(', ') : String(value);
}
